<!-- 民宿酒店  mjs -->
<template>
  <div class="travelServe homestayhotelContainer">
    <banner/>
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">民宿酒店</a>
      </div>
    </div> -->
    <crumbs />

    <div class="container">
      <div class="leftPart pb100 fl">
        <div class="labelBox">
          <type-screen modelType="homestayhotel" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="hotelList">

          <div  @click.stop="detaillink(item)" class="hotelItem" v-for="(item) in hotelList" :key="item.id">
            <div class="itemimg">
              <div class="tab" v-if="item.labelarr[0] !== undefined ">{{item.labelarr.length>0 ? item.labelarr[0]:''}}</div>
              <img :src="getImage(item.image)"  alt="">
            </div>
            <div class="itemtxt">
              <div class="title clearfix">
                <h2>{{item.name}}</h2>
                <span class="fr" v-if="item.price !== undefined && item.price !== ''">￥<i>{{item.price}}</i>起</span>
              </div>
              <div class="translate">{{item.name | getpinyi}} </div>
              <div class="itemlist">
                <div class="tab" v-if="item.labelarr[0] !== undefined " v-for="(val,i) in item.labelarr"
                     :key="'a'+ i">{{val}}</div>
              </div>
              <div class="itemfun">
                <span class="browsevalue">
                  <i></i>
                  <b>{{item.pv}}</b>
                </span>
                <span class="praisevalue">
                      <star
                        class="star"
                        starStyle="iconstar1"
                        :isSelect="item.isStar"
                        :count="item.star"
                        :menu-id="menuId"
                        :business-id="item.id"
                        @changecount="changePraise"
                        :title="item.name"
                        :image="item.image"
                        :url="'/homestayhoteldetail?columnId=' + item.menuId + '&id=' + item.id"
                      ></star>
                </span>
                <span class="collectvalue">
                  <collect
                    collect-style="iconcollect1"
                    :is-select="item.isCollect"
                    :count="item.collect"
                    @changecount="changeCollect"
                    :menu-id="menuId"
                    :business-id="item.id"
                    :title="item.name"
                    :image="item.image"
                    :url="'/homestayhoteldetail?columnId=' + item.menuId + '&id=' + item.id"
                  ></collect>
                </span>
              </div>
            </div>
          </div>
          <nodata v-show="nodataflag"/>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="homestayhotelparam.pageSize"
            :pager-count="5"
            layout="prev, pager, next"
            :total="total"
            class="flm pagemodel1"
          >
          </el-pagination>
        </div>

      </div>

      <div class="rightPart fr">
        <rightBox></rightBox>
      </div>

    </div>
  </div>
</template>

<script>
// import { isLogin } from '@/utils/index'
import star from '@/components/amount/star'
import collect from '@/components/amount/collect'
import { getTypeList } from '@/api/typescreen/index'
import crumbs from '@/components/crumbs/index'
import {getListAmount} from '@/api/datavolume/index'
import {getHomestayhotelList} from '@/api/homestayhotel/index'
import typeScreen from '@/components/typescreen/index'
import rightBox from '../../components/travelRight/index'
import pinyin from '../../../node_modules/js-pinyin/index'
import nodata from '@/components/nodata/index'
import banner from '@/components/banner/index'
export default {
  name: 'homestayhotel',
  components: {
    rightBox, typeScreen, crumbs, nodata, collect, star, banner
  },
  meta: {
    showHeader: true
  },
  filters: {
    getpinyi (value) {
      pinyin.setOptions({checkPolyphone: false, charCase: 0})
      return pinyin.getFullChars(value)
    }
  },
  data () {
    return {
      ifselect: false,
      menuId: '',
      phoneNum: '',
      total: 0,
      homestayhotelparam: {
        menuId: '',
        pageNum: 1,
        pageSize: 10,
        areaType: '',
        hotelType: '',
        hotelLabel: '',
        facilityService: '',
        customTypeId: ''
      },
      typeParams: {
        menuId: '',
        dictParentCode: 'hotelLabel,hotelFacilityService'
      },
      hotelList: [],
      nodataflag: false
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.homestayhotelparam.menuId = this.$route.query.columnId
    this.typeParams.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getHotelList()
    // console.log(this.hotelList)
  },
  methods: {

    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
        if (item.pv === undefined) item.pv = 0
        if (item.servearr === undefined) item.servearr = []
        if (item.labelarr === undefined) item.labelarr = []
      })
      getTypeList(this.typeParams).then(val1 => {
        // let labelarr = []
        let service = val1.data.data.dictType.hotelFacilityService.list
        let labels = val1.data.data.dictType.hotelLabel.list
        // console.log(service, labels)
        list.forEach((val, index) => {
          let servearr = []
          let labelarr = []
          let serviceBinkList = val.facilityServiceBinkList
          let labelBinkList = val.labelBinkList
          serviceBinkList.forEach((dd) => {
            service.forEach((demo, i) => {
              if (dd === demo.dictCode) {
                servearr.push(demo.dictName)
              }
            })
          })
          val.servearr = servearr

          labelBinkList.forEach((dd) => {
            labels.forEach((demo, i) => {
              if (dd === demo.dictCode) {
                labelarr.push(demo.dictName)
              }
            })
          })
          val.labelarr = labelarr
        })
      })
    },
    getHotelList () {
      getHomestayhotelList(this.homestayhotelparam).then(res => {
        // console.log(res.data, 'mjs')
        this.total = res.data.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        // this.hotelList = res.data.data.rows
        // let that = this
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }
        getListAmount(this.menuId, params).then(res1 => {
          // console.log(res1, 'res1')
          if (res1.data.data.length !== 0) {
            res1.data.data.forEach(item => {
              res.data.data.rows.forEach((val, index) => {
                if (item.dataId === val.id) {
                  val.collect = item.collect
                  val.isCollect = item.isCollect
                  val.pv = item.pv
                  val.isStar = item.isStar
                  val.star = item.star
                }
              })
            })
            this.defaultamout(res.data.data.rows)
          } else {
            this.defaultamout(res.data.data.rows)
          }
          this.hotelList = res.data.data.rows
        })
      })
    },

    selectType (obj) {
      this.homestayhotelparam.menuId = this.menuId
      this.homestayhotelparam.pageNum = 1
      this.homestayhotelparam.pageSize = 10
      this.homestayhotelparam.areaType = obj.areaType
      this.homestayhotelparam.hotelType = obj.hotelType
      this.homestayhotelparam.hotelLabel = obj.hotelLabel
      this.homestayhotelparam.facilityService = obj.facilityService
      this.homestayhotelparam.customTypeId = obj.customTypeId
      this.hotelList = []
      this.getHotelList()
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    detaillink (val) {
      if (val.url !== undefined && val.url !== '') {
        window.open(val.url)
      } else {
        this.$router.push({path: '/homestayhoteldetail', query: {id: val.id, columnId: this.menuId}})
      }
    },
    handleCurrentChange (val) {
      this.homestayhotelparam.pageNum = val
      this.hotelList = []
      this.getHotelList()
    },
    changeCollect (val) {
      this.hotelList.forEach(item => {
        if (item.id === val.id) {
          item.collect = val.count
          item.isCollect = val.isSelect
        }
      })
    },
    changePraise (val) {
      this.hotelList.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    }

  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";

.alpraised i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px 0px !important;
}
.alcollected i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px -64px !important;
}

.flm{
  float: left;
  position: relative;
  left: 45%;
}
</style>



// WEBPACK FOOTER //
// src/view/homestayhotel/list.vue